import { Component, Input, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AtlasModule } from '@galaxy/atlas';
import { ViewModeService } from '../../../../core/src/lib/view-mode.service';
import { Router } from '@angular/router';
import { GalaxyAiIconService } from '@vendasta/galaxy/ai-icon';
import { map } from 'rxjs';

@Component({
  selector: 'inbox-ai-button',
  standalone: true,
  templateUrl: 'inbox-ai-button.component.html',
  styleUrls: ['./inbox-ai-button.component.scss'],
  imports: [CommonModule, TranslateModule, MatIconModule, MatTooltipModule, AtlasModule],
})
export class InboxAIButtonComponent {
  @Input() isMobile = false;
  private readonly router = inject(Router);
  constructor(private readonly viewModeService: ViewModeService, private _: GalaxyAiIconService) {}

  readonly buttonSelected$ = this.viewModeService.isAIOpen$.pipe(
    map((isOpen) => (isOpen ? 'atlas-navbar__item-selected' : '')),
  );

  toggle(): void {
    this.viewModeService.toggleInboxAIOpen();
  }
}
